import { useState, useEffect } from "react";

export function useWindowSize() {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const onResize = () => setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });

        window.addEventListener("resize", onResize);
        onResize();
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return size;
}
